import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/home/runner/_work/injective-helix/injective-helix/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/runner/_work/injective-helix/injective-helix/layouts/default.vue").then(m => m.default || m)),
  institutional: defineAsyncComponent(() => import("/home/runner/_work/injective-helix/injective-helix/layouts/institutional.vue").then(m => m.default || m))
}